import React, { useEffect, useState } from 'react'
import styles from './authentications.module.css'
import { useAppContext } from '../../../../../../components/activity/AppContext';
import AuthenticationActions from '../../../../../administration/authentication/authentication.actions';

import Table from '../../../../../../components/Table/table';
import Pagination from '../../../../../../components/Pagination/pagination';
import PopUp from '../../../../../../components/layouts/PopUp';
import { useForm } from '../../../../../../components/forms/Form';
import { ProjectSettingsActions } from '../../../projectsettings.actions';
import SmallPopup from '../../../../../../components/layouts/smallPopup';


export default function Authentication({pageNumber, projectName, setSelectedIds, selectedIds, containerAppDetails, setContainerAppDetails, resetCADetails, handleClose, rolePopUp}) {
    const [currentAuthData, setCurrentAuthData] = useState({});
    const [authData,setAuthData] = useState({})
    const [saveChangesPopup, setSaveChangesPopup] = useState(false)
    const [isWebApp,_] = useState(containerAppDetails.containerApp.appType==="webApp")
    const [hadEdit, setHadEdit] = useState(0)
    const [clickedBack, setClickedBack] = useState(false)
    const [authError,setAuthError] = useState(false)
    const app = useAppContext();

    const [totalRecords,setTotalRecords] = useState(0);
    const [displayRows, setDisplayRows] = useState({
        offset: 0,
        limit: 10
    });
    const [isEdit, setEdit] = useState(false);
    const [buttonName1, setButtonName1] = useState("Cancel");
    const [buttonName2, setButtonName2] = useState("Save");
    const [enableState,setEnableState] = useState(0);

    const getAuthenticationCurrentData = async () => {
        const actions = AuthenticationActions(app());
        const [, data] = await actions.readAuthenticationData();
        if(data){
            const updatedData = data?.data.map(item => ({
                ...item,
                isChecked: selectedIds.includes(item.id)
            }));
            setCurrentAuthData(updatedData);
            setTotalRecords(data?.noOfRecords)
            const authIds = data?.data.map(e => e.id)
            let newSelectedIds = selectedIds.filter(e => authIds.includes(e))
            if(newSelectedIds.length != selectedIds.length){
                setHadEdit(1)
                setSelectedIds(newSelectedIds)
            }
        }
    }
    


    const fetchAuthenticationData = () => {
        getAuthenticationCurrentData();
    }

    useEffect(() => fetchAuthenticationData(), []);
    
    const initialAuthenticationArray = [
        { id: "name", name: "Name", type: "input" , disabled:true, width:"40%" },
        { id: "description", name: "Description", type: "input",disabled:true, width: "40%" },
        // { id: "authName", name: "Authentication Type", type: "input",disabled:true },
        {
            id: "isChecked",
            name: "",
            type:"checkBox",
            width:"10%"
          },
    ]

    const handleBack = (e)=>{
        // setAuthError(false)
        setClickedBack(true)
        setTimeout(()=>{
            if(hadEdit){
                submitHandler(e)
            }
            else {
                pageNumber(2)
            }
        },0)
    }
      
    const onWatch = (errors, values) => {
        // setHadEdit(1)
        // if(values.name == "universalWorkList") {
        //     getBusinessFunctionList (values.value == "Yes")
        // }
    }

    const updateContainerAppDetails = async (newValues) => {
        if(!isWebApp || (clickedBack || saveChangesPopup)) { /* write the draft changes condition */
            const prjAction = ProjectSettingsActions(app());
            const [err, data] = await prjAction.createNewCA(projectName, {...newValues})
            if(!err){
                const [err2, data2] = await prjAction.getContainerAppDetails(projectName, newValues.containerApp.id)
                    if(!err2) {
                        setContainerAppDetails({...data2.detail, genarate:false})
                    }
    
                if(data.status.type!=="E") saveChangesPopup?closePopup(false):pageNumber(clickedBack?2:3)
            }
        }
        else {
            const prjAction = ProjectSettingsActions(app());
            pageNumber(7)
            const [err, data] = await prjAction.createNewCA(projectName, {...newValues, genarate:true})
            if(!err) {
                const [err2, data2] = await prjAction.getContainerAppDetails(projectName, newValues.containerApp.id)
                    if(!err2) {
                        setContainerAppDetails({...containerAppDetails,...data2.detail})
                    }
    
                if(data.status.type!=="E") {
                    // console.log("containerAppDetails", containerAppDetails)
                    closePopup(false)
                    // pageNumber(8)
                }else{
                    //show failed logs
                }
            }
            else {
                // console.log("error", err)
                // pageNumber(8)
                closePopup(false)
            }
    
        }
    }

    const onSubmit = () => {
        let result = selectedIds.length
        if(result){
            setAuthError(false)
            if(!hadEdit&&!clickedBack&&!isWebApp) {pageNumber(3);return}
            const newCOntainerAppDetails = {
                ...containerAppDetails,
                containerApp:{
                    ...containerAppDetails.containerApp,
                    authentications:JSON.stringify(selectedIds)
                }
            }
            updateContainerAppDetails(newCOntainerAppDetails)
        }else{
            setAuthError(true)
            if(clickedBack) setClickedBack(false)
        }     
    }

    // const handleNext = async() => {

    //     if(props.selectedIds && props.selectedIds.length){
    //         const newCOntainerAppDetails = {
    //             ...props.containerAppDetails,
    //             containerApp:{
    //                 ...props.containerAppDetails.containerApp,
    //                 authentications:JSON.stringify(props.selectedIds)
    //             }
    //         }
    
    //         pageNumber(3)
    
    //         const prjAction = ProjectSettingsActions(app());
    //         const [err, data] = await prjAction.createNewCA(projectName, {...newCOntainerAppDetails, genarate:true})
    //     }
    //     else{
    //         setAuthError(true)
    //     }   
    // }


    const handleCheckBox = (value,key)=>{
        setHadEdit(1)
        setAuthError(false)
        const matchingItem = currentAuthData.find(item => item.name === key);

        if (matchingItem) {
            const id = matchingItem.id;
    
            if (value) {
                setSelectedIds(prev => [...prev, id]);
            } else {
                setSelectedIds(prev => prev.filter(item => item !== id));
            }
        }
    };
    
    const handleClosePopup = (bool) => {
        if(hadEdit) setSaveChangesPopup(true)
        else closePopup(bool)
    }

    const closePopup = (bool) => {
        resetCADetails();
        handleClose(bool)
    }
      
    const { Form, Label, Input, Error, Radio, submitHandler } = useForm(authData, onSubmit, onWatch);

    return (
        <PopUp  
        popUp={rolePopUp}
        setPopUp={handleClosePopup}
        titleClassName={styles.afModuleTitle}
        testId={"appAuthentications"}
        title="Choose your Authentications"
        subtitle="Enable required authentication for your new application">
            <Form>
            <div className={styles.formContent} style={{alignItems:"baseline"}}>
            <small style={{ color: 'red', display: 'block' , textAlign:"left", visibility:`${authError?"visible":"hidden"}` }}>
                        Authentication not selected
            </small>
            <div className={styles.tableWrapper}>

                    <Table
                        name={"AuthTable"}
                        // key={state}
                        data={currentAuthData}
                        headerColumns={initialAuthenticationArray}
                        checkBoxOnChange={handleCheckBox}

                    // handleHeaderInputChange={(id, value) => onChange(id, value)}
                    // handleHeaderSelectChange={(id, value) => onChange(id, value)}
                    />
            </div>

            </div>
                    {/* <Pagination
                        userDataCount={totalRecords}
                        displayRows={displayRows}
                        setDisplayRows={setDisplayRows} 
                    />
         */}
                 
                <div className='afPopupFooter'>
                    <div>
                        <Input data-clickable-testid="back" type="button" style={{ marginRight: "12px" }} className="secondary" value={"Back"} onClick={handleBack} />
                        <Input type="submit" value={isWebApp?"Generate":"Next"} style={isWebApp?{width:"fit-content",padding:"calc(var(--spacer) * 0.5px) calc(var(--spacer) * 2px)"}:{}}/>
                    </div>
                </div>
            </Form>
            {saveChangesPopup&&<SmallPopup testId={"saveChangesConfirmationPopup"} title={"Draft Changes"} subtitle={"Do you want to draft your changes?"} handleSubmit={(e)=>{submitHandler(e)}} icon={"saveChanges"} buttonTestId2={"Yes"} buttonTestId1={"No"} buttonName1={"No"} buttonName2={"Yes"} popUp={saveChangesPopup} handlePopUp={(e)=>{setSaveChangesPopup(false);if(e.target.tagName==="BUTTON") closePopup(false)}}/>}
        </PopUp>
    )
}
